
import StatesManager from './inc/StatesManager'
const segMx = new StatesManager.StateManipulator()

export { segMx }

